import peraWalletLogoSrc from "../../core/ui/images/PeraWalletLogo.svg";
import walletConnectLogoSrc from "../../core/ui/images/WalletConnectLogo.svg";
import deflyWalletLogoSrc from "../../core/ui/images/DeflyLogo.svg";

import {Wallet, WalletType} from "./walletTypes";

const AVAILABLE_WALLETS: Wallet[] = [
  {
    id: WalletType.PeraWallet,
    logo: peraWalletLogoSrc,
    logoAlt: "Pera Wallet logo",
    title: "Pera Wallet"
  },
  {
    id: WalletType.DeflyWallet,
    logo: deflyWalletLogoSrc,
    logoAlt: "Defly Wallet Logo",
    title: "Defly Wallet"
  },
  {
    id: WalletType.WalletConnect,
    logo: walletConnectLogoSrc,
    logoAlt: "Wallet Connect logo",
    title: "WalletConnect",
    description: "To use Wallet Connect compatible wallets, you can proceed from here"
  }
];

export {AVAILABLE_WALLETS};
